import type {ButtonAttrs} from '@jetbrains/ring-ui/components/button/button'
import Button from '@jetbrains/ring-ui/components/button/button'
import classNames from 'classnames'
import plur from 'plur'
import * as React from 'react'

import {useSequenceLoaderReadyHandler} from '../../SequenceLoader/SequenceLoader.hooks'

import styles from './ShowAllBuildTypes.css'

type Props = ButtonAttrs & {
  count: number
  className?: string
  seqKey?: string
}

function ShowAllBuildTypes({count, className, seqKey, ...restProps}: Props) {
  useSequenceLoaderReadyHandler(true)
  return (
    <Button
      text
      className={classNames(styles.button, className)}
      {...restProps}
    >{`Show all ${count} ${plur('configuration', count)}`}</Button>
  )
}

export default ShowAllBuildTypes
